"use client";

// A quiet media preview — image, or a video's poster (falling back to the video
// element itself, muted + metadata-only, when no poster was provided).

import type { CompanyMedia } from "../../lib/company/types";

/** the still shown for a media (image, video poster, or youtube thumbnail). */
export function thumbSrc(m: CompanyMedia): string | null {
  if (m.type === "youtube") return m.poster || (m.videoId ? `https://img.youtube.com/vi/${m.videoId}/maxresdefault.jpg` : null);
  if (m.type === "video") return m.poster ?? null;
  return m.src;
}

export default function MediaThumb({ m }: { m: CompanyMedia }) {
  const src = thumbSrc(m);
  if (src) {
    // eslint-disable-next-line @next/next/no-img-element
    return <img src={src} alt={m.alt ?? ""} draggable={false} />;
  }
  if (m.type === "video") return <video src={m.src} muted playsInline preload="metadata" />;
  return null;
}

export function Byline({
  author,
  category,
  when,
  draft,
}: {
  author: string;
  category: string;
  when: string;
  draft?: boolean;
}) {
  return (
    <span className="co-by">
      <span>by <b style={{ fontWeight: 400, color: "var(--ink-2)" }}>{author}</b> in <u>{category}</u></span>
      <span className="ink-dot" aria-hidden />
      {/* ⚠️ `when` is a RELATIVE time (relTime), computed from `now`. The server
          renders it at request time and the client hydrates a moment later, so
          "59m" can legitimately become "1h" between the two — which React
          counts as a hydration mismatch (#418, seen live on /company). The
          value is cosmetic and the client's is the more correct one, so the
          difference is declared rather than fought. */}
      <span suppressHydrationWarning>{when}</span>
      {draft && <span style={{ color: "var(--ink-4)" }}>· draft</span>}
    </span>
  );
}
